import { useState, useEffect } from 'react'
import './navMob.css'
import { Link, useLocation } from 'react-router-dom'
import details from"../dataStore/details.json"

export default function NavMob(){
    const [menuVisible, setMenuVisible] = useState(false)
    const location = useLocation()
    const path = location.pathname.substring(1)

    const [pageScroll, setpageScroll] = useState(false);
    const handleScroll = () => {
        const position = window.scrollY;
        if (position >= 100) {
            setpageScroll(true) 
        } else {
            setpageScroll(false) 
        }
      };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return(
        <>
        <nav className={pageScroll?'navMobContainer navMobScrolled':'navMobContainer '}>
            <figure>
                <Link to='/'>
                    {/* <img src='./images/footerLogo.svg' alt='Zion Cab'/> */}
                    <h2>{details.name}</h2>
                    <p>24/7 Taxi Service</p>
                </Link>      
            </figure> 

            <div className='menuBtn' onClick={()=>setMenuVisible(!menuVisible)}>
                <div className={menuVisible?'bar bar1':'bar'}/>
                <div className={menuVisible?'bar bar2':'bar'}/>
                <div className={menuVisible?'bar bar3':'bar'}/>
                <div className={menuVisible?'bar bar4':'bar'}/>
            </div>
        </nav>
        <div className={menuVisible?'swipe':'swipe right'}>
            <div className='menuContainerMobile'>
                <Link to='/' className={path===''?'indicator swipeItem':'swipeItem'} onClick={()=>setMenuVisible(!menuVisible)}>Home</Link>
                <Link to='/tariff' className={path==='tariff'?'indicator swipeItem':'swipeItem'} onClick={()=>setMenuVisible(!menuVisible)}>Tariff</Link>
                <Link to='/contact' className={path==='contact'?'indicator swipeItem':'swipeItem'} onClick={()=>setMenuVisible(!menuVisible)}>Contact Us</Link>
            </div>
        </div>
        </>
    )
}